export function formatMediumDate(timestampMillis: number, language: string): string {
  return new Intl.DateTimeFormat(language, { dateStyle: 'medium' }).format(timestampMillis);
}
